import React from 'react';
import styled from 'styled-components';
import { classic } from '~/themes';

type IProps = {
  color: 'primary' | 'secondary' | 'grey';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  type?: 'button' | 'submit' | 'reset';
  ref?: any;
  margin?: string;
};

export default function ButtonSmall({
  color,
  onClick,
  children,
  disabled,
  hidden,
  type,
  margin,
  ref,
}: IProps) {
  return (
    <Container
      color={color}
      disabled={disabled}
      hidden={hidden}
      onClick={onClick}
      ref={ref}
      type={type}
      $margin={margin}
    >
      {children}
    </Container>
  );
}

const Container = styled.button<{
  color: 'primary' | 'secondary' | 'grey';
  disabled?: boolean;
  hidden?: boolean;
  opaque?: boolean;
  $margin?: string;
  $textTransform?: string;
}>`
  align-items: center;
  border-radius: 13px;
  border: none;
  box-shadow: 0px -3.2px 2.4px 0px rgba(0, 0, 0, 0.25) inset;
  background: ${({ color }) => {
    if (color === 'primary')
      return `linear-gradient(180deg, #53d2d7 0%, #27c4ca 100%)`;
    if (color === 'secondary')
      return `linear-gradient(180deg, #EA7A49 0%, #EF6226 100%)`;
    if (color === 'grey')
      return `linear-gradient(180deg,rgba(159, 159, 159, 0.8) 0%, #878787 100%)`;

    return 'transparent';
  }};
  color: ${classic.token?.colorWhite};
  cursor: pointer;
  display: ${({ hidden }) => (hidden ? 'hidden' : 'flex')};
  flex-direction: row;
  font-family: 'Riffic Free', sans-serif;
  font-size: 1rem;
  font-weight: 700;
  justify-content: center;
  letter-spacing: normal;
  margin: ${({ $margin }) => ($margin ? $margin : '2px')};
  min-width: 180px;
  opacity: ${({ disabled, hidden }) => {
    if (hidden) return 0;
    if (disabled) return 0.5;

    return 1;
  }};
  padding: 3px 12px;
  pointer-events: ${({ disabled, hidden }) =>
    (disabled ?? hidden) ? 'none' : 'auto'};
  text-transform: ${({ $textTransform }) => $textTransform ?? 'uppercase'};
  transition: all 0.6s linear;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  outline: none;
  @media screen and (max-height: 800px) {
    font-size: 0.9rem;
    padding: 3px 12px;
  }

  @media screen and (max-width: 450px) {
    font-size: 0.8rem;
    padding: 3px 12px;
    min-width: 150px;
  }
  @media screen and (max-height: 450px) {
    margin: 2px;
    font-size: 0.8rem;
    min-width: 150px;
  }

  &:focus {
    background: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return 'transparent';
    }};
    font-weight: bold;
    outline: none;
  }

  &:hover {
    background: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return 'transparent';
    }};
  }
`;
